var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "product-describe relative mb-2 w-[calc(100%-2rem)] mx-auto",
    },
    [
      _c(
        "van-collapse",
        {
          model: {
            value: _vm.activeNames,
            callback: function ($$v) {
              _vm.activeNames = $$v
            },
            expression: "activeNames",
          },
        },
        _vm._l(_vm.sections, function (section) {
          return _c(
            "van-collapse-item",
            {
              key: section.name,
              attrs: { title: section.title, name: section.name },
              scopedSlots: _vm._u(
                [
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "flex items-center h-full w-full" },
                          [
                            _c("span", { staticClass: "text-[15px]" }, [
                              _vm._v(_vm._s(section.title)),
                            ]),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            },
            [
              _c(
                "div",
                {
                  staticClass: "p-2 pl-6 bg-white rounded-lg flex items-center",
                },
                [
                  _c("div", {
                    staticClass: "text-sm text-gray-500 value-text",
                    domProps: { innerHTML: _vm._s(section.value) },
                  }),
                ]
              ),
            ]
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }